/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    view: {
        'class': 'product-item clearfix',
        'data-state':nb.bind('itemState'),
        $html: [{
            'class': 'product-describe',
            $html: [{
                tag:'a',
                href:nb.bind('href'),
                target:'_blank',
                title:nb.bind('cnName'),
                $html:{
                    tag: 'img',
                    src: nb.bind('imgUrl')
                }
            }, {
                'class': 'product-name',
                $html: [{
                    'class': 'cn-name uk-text-truncate',
                    tag:'a',
                    href:nb.bind('href'),
                    target:'_blank',
                    title:nb.bind('cnName'),
                    $text: nb.bind('cnName')
                }, {
                    'class': 'en-name uk-text-truncate',
                    tag:'a',
                    href:nb.bind('href'),
                    target:'_blank',
                    title:nb.bind('enName'),
                    $text: nb.bind('enName')
                }]
            }]
        }, {
            'class': 'product-spec uk-text-truncate',
            title:nb.bind('spec'),
            $text: nb.bind('spec')
        }, {
            'class': 'product-price',
            // title:nb.bind('price'),
            $html:[{
                'class':'product-price1',
                $text: nb.bind('price')
            },{
                'class':'product-disPrice',
                $text: nb.bind('disPrice')
            }]
        }, {
            'class': 'product-num',
            title:nb.bind('number'),
            $text: nb.bind('num')
        }, {
            'class': 'product-total-price',
            title:nb.bind('totalPrice'),
            $text: nb.bind('totalPrice')
        }]
    },
    method: {
        init: function () {
            var self = this;
            // this.$('btn-ask-price').on('click', function () {
            //     self.getModel().set('enquiryStatus');
            // })
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/view/ProductItem.js
// module id = 684
// module chunks = 3